<template>
  <teleport to="body">
    <div :class="fadeTransition" class="modal">
      <div :class="bounceTransition" class="modal-body">
        <div class="modal-header">
          <h1>{{ title }}</h1>
          <div style="height: 30px; width: 30px" v-on:click="closeModal">
            <CloseSVG :propId="'save-label-close'" />
          </div>
        </div>
        <form v-on:submit.prevent>
          <div class="form-group">
            Would you like to save your design before exiting?
            
            If you don't save, your current changes will be lost.
          </div>
          <div class="form-group">
            <label for="save-artwork">Design Name</label>
            <input id="save-artwork" class="form-input" v-model="artworkName" required />
          </div>
          <div v-if="!loading" class="buttons-wrap">
            <button
                @click="goBack(false)"
                class="modal-select-btn go-back"
                type="submit"
                aria-label="Go back">
                No, don't save
            </button>
            <button
                @click="goBack(true)"
                class="modal-select-btn"
                type="submit"
                aria-label="Save label and go back">
                Save and go back
            </button>
          </div>
          <div v-else id="loading-wrap">
            <img src="@/assets/loader.svg" />
          </div>
        </form>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, ref, Ref, onMounted, inject, computed } from "vue";
import CloseSVG from "@/components/CloseSVG.vue";
import useSaveAndContinue from "@/composables/useSaveAndContinue";
import { getEditorUrlParam } from "@/composables/useParseURL";
import { store } from "@/store";

export default defineComponent({
  name: "ConfirmBack",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const loading = ref<boolean>(false);
    const backUrl = window.document.referrer;
    const artworkName = ref<string>('Design 1');

    if (store.getters.userArtworkFetch.artwork && Object.keys(store.getters.userArtworkFetch.artwork).length)
      artworkName.value = store.getters.userArtworkFetch.artwork.title;

    const goBack = async (save = false) => {
        loading.value = true;
        if (save) {
            loading.value = await useSaveAndContinue({
                title: artworkName.value,
                noRedirect: true,
            });
        }
        
        window.location.href = backUrl;
    }

    const title = ref("");
    onMounted(() => {
      //Trigger rerender on mount
      title.value = "Save your changes?";
    });

    return {
      closeModal,
      fadeTransition,
      bounceTransition,
      loading,
      title,
      artworkName,
      goBack,
    };
  },
});
</script>

<style scoped>
.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 400px;
  height: unset;
  padding: 4rem;
  padding: 25px;
  border-radius: 6px;
  overflow: auto;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.modal-header h1 {
  font-weight: 600;
  font-size: 22px;
  letter-spacing: -0.25px;
}

.close {
  border-radius: 50%;
  border: solid 1px black;
  background-color: white;
  height: 25px;
  width: 25px;
}

form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.form-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  margin-bottom: 2rem;
}

.form-group:first-child {
  margin-top: 2rem;
}

.form-group label {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
}

.form-input {
  border-radius: 4px;
  border: 1px solid #ccc;
  height: 25px;
  padding: 6px 12px;
}

.form-input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%),
    0 0 8px rgb(102 175 233 / 60%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
}

#loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons-wrap {
    display: flex;
    margin-top: 5px;
}

.modal-select-btn {
  border: none;
  border-radius: 4px;
  background: #ff6c00;
  color: white;
  font-size: 16px;
  padding: 1.5rem;
  text-decoration: none;
  text-align: center;
  width: 100%;
  text-shadow: none;
  cursor: pointer;
}

.modal-select-btn:hover {
  background: linear-gradient(to bottom, #ff994e 0%, #ff6c00 100%);
}

.modal-select-btn.go-back {
    color: #0096ff;
    background: transparent;
    margin-right: 15px;
}

@media (max-width: 767px) {
  .modal-body {
    position: fixed;
  }
}

@media (max-width: 500px) {
  .modal-body {
    width: 95%;
  }
}
</style>
